import { InjectionToken } from '@angular/core';

import {
  Authenticator,
  CommandQueueRunner,
  DatabaseCreator,
  FtsIndexFinalizer,
  IndexRebuilder,
  MaintenanceSynchroniser,
  MaintenanceWatchStarter,
  ProduktlyInitializer,
  RootHistorySetter,
  ShutdownInfoListener,
  SyncIndicatorCloser,
  SyncIndicatorOpener,
  SyncIndicatorPreCloser,
  SyncStarter,
  TokenHandler,
  WebSyncStarter,
} from '../contracts/sync/sync-endpoints';

export const syncOrder = [
  SyncIndicatorPreCloser,
  TokenHandler,
  Authenticator,
  DatabaseCreator,
  SyncIndicatorOpener,
  IndexRebuilder,
  MaintenanceSynchroniser,
  MaintenanceWatchStarter,
  ShutdownInfoListener,
  CommandQueueRunner,
  RootHistorySetter,
  SyncStarter,
  WebSyncStarter,
  // After data sync, before the indicator closes: rebuild any FTS index left incomplete by the
  // initial sync (which skips per-item index writes). Gating here guarantees the indicator only
  // closes once the search index is fully built.
  FtsIndexFinalizer,
  SyncIndicatorCloser,
  ProduktlyInitializer,
];

export const SyncOrderToken = new InjectionToken<string[]>('SyncOrder', {
  providedIn: 'root',
  factory: () => syncOrder,
});
